import { useTranslation } from "react-i18next";
import useClientConfig from "../hooks/clientConfigHook";
import { useEffect, useMemo, useRef } from "react";
import { FloatingLabel } from "./FloatingLabel";

const makeUnits = t => [
    { label: 'y', seconds: 60 * 60 * 24 * 365 },
    { label: 'mo', seconds: 60 * 60 * 24 * 30 },
    { label: 'w', seconds: 60 * 60 * 24 * 7 },
    { label: 'd', seconds: 60 * 60 * 24 },
    { label: 'h', seconds: 60 * 60 },
    { label: 'm', seconds: 60 },
    { label: 's', seconds: 1 }
]
const updateClock = (t, units, base, description) => () => {
    if (base == null) {
        return '';
    }

    const seconds = Math.floor((Date.now() - base) / 1000);
    if (seconds < 0) {
        return t('timeFuture');
    }

    for (const unit of units) {
        const value = Math.floor(seconds / unit.seconds);
        if (value >= 1) {
            return t('timeAgo', { value, label: unit.label, description });
        }
    }
    return t('timeJustNow');
}

export const customCtrlDef = {
    toString: ({ def, value, clientConfig, t }) => {
        const units = makeUnits(t);
        return updateClock(t, units, value, def.description)();
    },
    def: (t, tools) => ({
        form: [{
            borderless: true,
            rows: [
                ...tools.labelFields(t),
                ...tools.fieldFields(t),
                [
                    { type: "text", field: "description", label: t('description') }
                ],
                ...tools.commonFields(t)
            ]
        }]
    }),
    control: ({ def, value, ...props }) => <ElaspedClock baseDate={value} description={def.description} {...props}></ElaspedClock>
}

const intervalFunctions = [];
setInterval(() => {
    intervalFunctions.forEach(f => f());
}, 1000);

const ElaspedClock = ({ baseDate, placeholder, description, hideLabel = false }) => {
    const { t } = useTranslation('common');
    const clientConfig = useClientConfig();
    const clockDiv = useRef();
    const base = useMemo(() => new Date(baseDate), [baseDate]);
    const units = useMemo(() => makeUnits(t), [t]);
    
    useEffect(() => {
        const update = updateClock(t, units, base, description);
        const applyUpdate = () => {
            if (clockDiv.current) {
                clockDiv.current.innerHTML = update();
            }
        }
        intervalFunctions.push(applyUpdate);
        return () => {
            let idx = intervalFunctions.indexOf(applyUpdate);
            intervalFunctions.splice(idx, 1);
        };
    }, [clientConfig, base, t, description, units]);

    return <FloatingLabel placeholder={placeholder ?? ' '} value={true} hideLabel={hideLabel}><span ref={clockDiv}></span></FloatingLabel>;
}

export default ElaspedClock;